<template>
	<div class="impact-details-content">
		<Accordion title="Form Details" v-model="accordion.first">
			<template #body-content>
				<div class="form-details">
					<span v-if="!hasResults">No Fields Added</span>
					<div class="form-details__search" v-if="hasResults">
						<Search
							v-model="searchReference"
							variant="toggle-icons"
							placeholder="Search reference"
							:enableTimeOut="false"
						/>
					</div>
					<div class="form-details__table">
						<Table
							:sourceObject="tableSource"
							v-if="hasResults"
							:editable="false"
							ref="tableForms"
							@change="updatePagination"
							class="table-container--form-details"
						>
							<template #col-group>
								<colgroup>
									<col
										class="table__col table__col--field-ref"
									/>
									<!-- Field Reference -->
									<col
										class="table__col table__col--field-type"
									/>
									<!-- Field Type -->
									<col class="table__col table__col--row" />
									<!-- Row -->
									<col class="table__col table__col--dot" />
									<!-- Dot -->
									<col
										class="table__col table__col--column"
									/>
									<!-- Column -->
								</colgroup>
							</template>
							>
							<template #body-fieldReference="{ body }">
								<div class="form-details__reference-field">
									<DivEllipsis
										:data="formFieldReferences(body)"
									></DivEllipsis>
								</div>
							</template>
							<template #body-fieldType="{ body }">
								<div class="form-details__type">
									<span class="form-details__type-text">
										{{ formImpactType(body.impactType) }}
										<BadgeCount
											:value="body.order"
											v-if="body.impactType === 'I'"
										/>
									</span>
								</div>
							</template>
							<template #body-row="{ body }">
								<span>{{ body.row }}</span>
							</template>
							<template #body-dot="{ body }">
								<span>{{ body.dot }}</span>
							</template>

							<template #body-col="{ body }">
								<span>{{ body.col }}</span>
							</template>
						</Table>
					</div>
				</div>
			</template>
		</Accordion>
	</div>
</template>

<script>
import Table from '@/components/shells/table/table';
import Search from '@/components/forms/search/search';
import BadgeCount from '@/components/visual/badge-count';
import DivEllipsis from '@/components/visual/ellipsis';
import Accordion from '@/components/shells/accordion/accordion';
import ImpactContent from '@/mixins/forms/impact-content';

export default {
	name: 'ImpactDetailsContent',
	mixins: [ImpactContent],
	components: {
		Search,
		Table,
		BadgeCount,
		DivEllipsis,
		Accordion
	},
	model: {
		prop: 'impactInputFields'
	},
	props: {
		label: {
			type: String,
			default: ''
		},
		isLabelBefore: {
			type: String,
			default: '' //is-label-before
		},
		btnClick: {
			type: Function,
			default: () => {}
		},
		impactInputFields: {
			type: Array,
			default: () => {}
		}
	},
	data() {
		return {
			impactInputFieldsList: [],
			tableSource: {
				headers: [
					{
						key: 'fieldReference',
						label: 'Field Reference',
						sorteable: false
					},
					{
						key: 'fieldType',
						label: 'Field Type',
						sorteable: false
					},
					{
						key: 'row',
						label: 'R',
						sorteable: false
					},
					{
						key: 'dot',
						label: 'D',
						sorteable: false
					},
					{
						key: 'col',
						label: 'C',
						sorteable: false
					}
				],
				displayHeader: true,
				source: {}
			},
			dataPage: 1,
			pageSize: 10,
			searchReference: '',
			accordion: {
				first: true
			}
		};
	},

	methods: {
		getPrompList() {
			let impactsList = [...this.impactInputFieldsList];
			let results = [];
			if (impactsList.length > 0) {
				let impactsListReduced = impactsList.reduce(
					(impacts, impact) => {
						let keyboardPrompt = impact.keyboardPrompt;
						if (keyboardPrompt) {
							impacts.push(keyboardPrompt);
						}
						return impacts;
					},
					[]
				);
				results = [...new Set(impactsListReduced)];
			}
			return results;
		}
	},
	watch: {
		impactInputFields: {
			deep: true,
			immediate: true,
			handler() {
				if (this.impactInputFields) {
					this.impactInputFieldsList = [...this.impactInputFields];
				}
			}
		},
		impactInputFieldsList: {
			deep: true,
			immediate: true,
			handler() {
				this.prompTypes = this.getPrompList();
				this.generateSource(this.dataPage, this.pageSize);
			}
		}
	}
};
</script>

<style lang="scss">
/**
  * Impact Form details
  * Can use SCSS variables = TRUE
*/

.impact-details-content {
	background: $white;
	padding: $padding-md $padding-sm;
	@include mq($until: sm-l) {
		margin-left: -8px;
		margin-right: -8px;
		border-top: 1px solid $neutral-3;
	}

	@include mq($from: sm-l) {
		padding: 0;
	}
	@include mq($from: md) {
		border: none;
		padding: 0;
	}

	&__wrapper {
		margin-bottom: $gutter-xl;
	}
}

.form-details {
	padding: $padding-md;

	&__search {
		@include mq($from: md) {
			max-width: 260px;
		}
	}

	&__table {
		margin-top: $gutter-lg;
	}

	&__type-text {
		display: inline-flex;
		align-items: center;
	}

	.badge-count {
		margin-left: $gutter-sm;
	}
}

.table-container--form-details {
	.table {
		@include mq($from: md) {
			table-layout: fixed;
		}
	}
	.table__col {
		width: 100%;

		@include mq($from: md) {
			&--field-ref {
				width: auto;
			}
			&--field-type {
				width: 155px;
			}
			&--row,
			&--dot,
			&--column {
				width: 65px;
			}
		}
	}
}
</style>
